var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilledDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4383 12.3263C17.1592 10.7154 17.2207 8.89173 16.6098 7.23714L16.5966 7.06793C16.294 6.31003 15.591 6.00808 15.1126 6.19778C15.6047 5.81389 15.5374 4.81514 14.7498 4.16549C14.0682 3.59504 13.2855 3.15378 12.4413 2.86394C11.5935 2.57826 10.6973 2.45885 9.80306 2.5125C8.94933 2.56235 8.11055 2.75604 7.32307 3.08518C6.54868 3.41096 5.8283 3.84971 5.18607 4.38674C3.86788 5.46443 2.96833 6.95903 2.64013 8.61678C2.46086 9.46724 2.45352 10.3443 2.61856 11.1976C2.78359 12.0508 3.11777 12.8635 3.60187 13.589C4.08598 14.3146 4.71048 14.9387 5.4396 15.4255C6.16873 15.9124 6.9881 16.2524 7.85072 16.4261C9.53314 16.7851 11.2883 16.5932 12.8503 15.8795C14.4485 15.1708 15.7259 13.9058 16.4383 12.3263Z",
    fill: "#173962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilledDot);
export default __webpack_public_path__ + "static/media/filled-dot.fcee9e6f7b89f10fec9c00aed67ba431.svg";
export { ForwardRef as ReactComponent };